import { Box, Typography, Grid, Stack, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { FaRegFileAlt } from 'react-icons/fa';
import { BsPlayBtn } from 'react-icons/bs';
import ProfilePic from '../../ProfilePic';
import subCategoryIcon from '../../../../assets/SvgIcons/resources/subCategory.svg';
import resourceMic from '../../../../assets/SvgIcons/resources/Categoryrecorder.svg';

interface NetworkCompanyType {
	companyId: string;
	relationName: string;
	isMeSender: boolean;
	companyName: string;
	count: {
		category: number;
		article: number;
		video: number;
		podcast: number;
		document: number;
	};
}

interface CompanyDetailProps {
    selectedCompany: NetworkCompanyType;
    labelText: string;
}

const CompanyDetail: React.FC<CompanyDetailProps> = ({ selectedCompany, labelText }) =>
{
	const companyAbout = selectedCompany?.relationName || 'N/A';
	const [ isImageLoaded, setIsImageLoaded ] = useState(false);
	const handleImageLoad = () =>
	{
		setIsImageLoaded(true);
	};

	return (
		<Box p={2}>
			<Box display='flex' flexDirection='column' alignItems='center' mb={2}>
				<Box sx={{ width: '128px', height: '128px', mb: 1 }}>
					<ProfilePic
						imagePath={`${selectedCompany.companyId}_logo_thumbnail.jpeg`}
						defaultImg='/images/logos/no_logo.png'
						alt={selectedCompany.companyName || 'Company'}
						style={{ width: '128px', height: '128px' }}
						className={`brdrRadius50 ${isImageLoaded ? '' : 'shimmer'}`}
						onLoad={handleImageLoad}
					/>
				</Box>
			</Box>
			<Typography variant='h6' fontSize='var(--pixel16)' fontWeight={600} color='var(--darkgray)' mb={2}>
				{selectedCompany.companyName || ''}
			</Typography>

			{/* Content Count Display */}
			<Box mb={2}>
				<Grid container spacing={1} justifyContent='space-between'>
					{[
						{ tooltip: 'Categories', icon: subCategoryIcon, count: 0, type: 'img' },
						{ tooltip: 'Articles', icon: '/images/icons/ArticleContent.svg', count: selectedCompany?.count?.article || 0, type: 'img' },
						{ tooltip: 'Videos', icon: <BsPlayBtn fontSize={12} />, count: selectedCompany?.count?.video || 0 },
						{ tooltip: 'Podcasts', icon: resourceMic, count: selectedCompany?.count?.podcast || 0, type: 'img' },
						{ tooltip: 'Documents', icon: <FaRegFileAlt fontSize={12} />, count: selectedCompany?.count?.document || 0 }
					].map((value, index) => (
						<Grid key={index} item display='flex' alignItems='center' xs color='#6B7280'>
							<Tooltip
								title={value.tooltip}
								placement='top'
								arrow
								enterDelay={100}
								leaveDelay={200}
							>
								<Stack direction='row' display='flex' alignItems='center' spacing={0.5}>
									{value.type !== 'img'
										? <Box>{value.icon}</Box>
										: <Box component='img' src={typeof value.icon === 'string' ? value.icon : ''} alt={'index'} width={12} height={12}/>}
									<Typography variant='inherit' fontSize='14px'>{value.count}</Typography>
								</Stack>
							</Tooltip>
						</Grid>
					))}
				</Grid>
			</Box>

			<Typography
				fontSize='var(--pixel14)'
				color='var(--darkgray)'
				sx={{
					whiteSpace : 'pre-wrap',
					wordBreak  : 'break-word'
				}}
			>
				{companyAbout}
			</Typography>
			{/* {selectedCompany.industryTypes && selectedCompany.industryTypes.length > 0 && (
				<Box mb={2}>
					<Typography
						fontSize='var(--pixel14)'
						color='var(--darkgray)'
						sx={{
							whiteSpace : 'pre-wrap',
							wordBreak  : 'break-word'
						}}
					>
						Industry: {selectedCompany.industryTypes.join(', ')}
					</Typography>
				</Box>
			)}

			{selectedCompany.relationName && (
				<Box mb={2}>
					<Typography
						fontSize='var(--pixel14)'
						color='var(--darkgray)'
						sx={{
							whiteSpace : 'pre-wrap',
							wordBreak  : 'break-word'
						}}
					>
						Relation: {selectedCompany.relationName}
					</Typography>
				</Box>
			)}

			{selectedCompany.role && (
				<Box mb={2}>
					<Typography
						fontSize='var(--pixel14)'
						color='var(--darkgray)'
						sx={{
							whiteSpace : 'pre-wrap',
							wordBreak  : 'break-word'
						}}
					>
						Role: {selectedCompany.role}
					</Typography>
				</Box>
			)} */}
		</Box>
	);
};

export default CompanyDetail;